import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27432c41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-result__img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M41.4005 48L18.3005 71.1C18.3005 71.1 15.0005 74.4 18.3005 77.7C21.6005 81 24.9005 77.7 24.9005 77.7L48.0005 54.6L71.1005 77.7C71.1005 77.7 74.4005 81 77.7005 77.7C81.0005 74.4 77.7005 71.1 77.7005 71.1L54.6005 48L77.7005 24.9C77.7005 24.9 81.0005 21.6 77.7005 18.3C74.4005 15 71.1005 18.3 71.1005 18.3L48.0005 41.4L24.9005 18.3C24.9005 18.3 21.6005 15 18.3005 18.3C15.0005 21.6 18.3005 24.9 18.3005 24.9L41.4005 48Z",
      fill: "#E05757"
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-result__title" }, "Произошла ошибка", -1))
const _hoisted_4 = { class: "pay-result__text" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-result__img" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "97",
    height: "97",
    viewBox: "0 0 97 97",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M83.2951 21.0685C85.0037 22.4923 85.2345 25.0316 83.8107 26.7402L43.5408 75.064C42.8165 75.9332 41.76 76.4576 40.6297 76.5088C39.4994 76.5601 38.3997 76.1335 37.5997 75.3335L13.4378 51.1716C11.8651 49.5989 11.8651 47.0492 13.4378 45.4766C15.0104 43.9039 17.5602 43.9039 19.1328 45.4766L40.1766 66.5204L77.6235 21.5841C79.0473 19.8756 81.5865 19.6447 83.2951 21.0685Z",
      fill: "#4B8371"
    })
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-result__title" }, "Ваш заказ оплачен", -1))
const _hoisted_8 = { class: "pay-result__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.status != 'pay-success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, "Заказ №" + _toDisplayString(_ctx.order) + " не был оплачен", 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, "№" + _toDisplayString(_ctx.order), 1),
          _createElementVNode("button", {
            type: "button",
            class: "pay-result__btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openOrderHistory && _ctx.openOrderHistory(...args)))
          }, " История заказов ")
        ]))
  ]))
}